import React from "react";
import Markdown from "react-markdown";
import {Link, Typography} from "@mui/material";
import {TranslateFunction} from "./Forms";

export const FORM_NAME = 'umr-fb12-marcia';
export const FORM_VERSION = '2.0.0';
export const FORM_DATE = '2025-11-10';

export const SMALL_WINDOW_WIDTH = 1250;

function LinkRenderer(props: any) {
    return (
        <Link href={props.href} target="_blank" underline="none">{props.children}</Link>
    );
}

function ParagraphRenderer(props: any) {
    return (
        <Typography variant="body2" component="p" gutterBottom>
            {props.children}
        </Typography>
    );
}

function ListItemRenderer(props: any) {
    return (
        <Typography variant="body2" component="li" gutterBottom>
            {props.children}
        </Typography>
    );
}
interface FromMarkdownProps {
    children?: string | null | undefined;
}

export default function FromMarkdown({children}: FromMarkdownProps) {
    return (<Markdown components={{
        a: LinkRenderer,
        p: ParagraphRenderer,
        li: ListItemRenderer
    }}>
        {children}
    </Markdown>);

}

export type Substitution = { [k: string]: string };

export type I18nMessage = { key: string, substitution: Substitution } | string;

export function translate(message: I18nMessage, t: TranslateFunction) {
    return (typeof message === "string" ?
        t(message) :
        t(message.key, getTranslatedSubstitution(t, message.substitution)))
}

function getTranslatedSubstitution(t: TranslateFunction, substitution: Substitution) {
    const translatedSubstitution = {...substitution};

    const keys = Object.keys(translatedSubstitution);

    // eslint-disable-next-line no-template-curly-in-string
    for (let k = 0; k < keys.length; k++) {
        translatedSubstitution[keys[k]] = t(translatedSubstitution[keys[k]]);
    }
    return translatedSubstitution;
}